export default {
  new: 1,
  included: 2,
  documentsBeingChecked: 3,
  documentAccepted: 4,
  withdrawnFromChildChoicePath: 5,
  excluded: 6
} as const
